import React from "react";
import "./Radio.scss";

const checked = () => {
  return (
    <div className="checked">
      <p>Check</p>
    </div>
  );
};

type RadioTypes = {
  id: string;
  name: string;
};

type AppProps = {
  onPress: (id: string) => void;
  value: string;
  data: RadioTypes;
  alignment?: string;
  backGround?: boolean;
  schedulingFilterRadio?: boolean;
  diasableId?: string;
  disable?: boolean;
};

const Radio = ({ onPress, value, data, alignment, backGround, schedulingFilterRadio, diasableId, disable }: AppProps) => {
  const { id, name } = data;
  return (
    <div
      style={{ background: backGround && value === id ? "#E1E9F0" : "" }}
      onClick={() => !disable  && onPress(id)}
      className={
        schedulingFilterRadio ? "scheduling-radio d-flex" : alignment === "vertical"
          ? "radio-container-vertical"
          : "radio-container-horizontal"
      }
    >
      {value === id ? (
        <div className="checked-radio">
          <div className="check-fill"></div>
        </div>
      ) : (
        <div className={diasableId || disable ? "disabled-radio-btn" : "unchecked"}></div>
      )}
      <span className={schedulingFilterRadio ? "ml-2 mdf" : "ml-2"} style={{ opacity: diasableId === id ? "0.7" : "", cursor: diasableId === id ? "auto" : "pointer" }}>{name}</span>
    </div>
  );
};

export default Radio;
